import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/logo.png";   //Ziogram logo 
import logo from '../../assets/SnaptaLogo.png' //
import Snapta from "../../assets/Snapta.png";
import Dashboard1 from "../../assets/dashboard1.png";
import Dashboard2 from "../../assets/dashboard2.png";
import Dashboardh from '../../assets/dahboardh.png'
import PostList1 from "../../assets/PostList1.png";
import PostList2 from '../../assets/PostList2.png';
import PostListh from '../../assets/PostListh.png'

import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar } from "../../store/slice/StoreSidebarValue";
// import PostListh from '../../assets/Post'
import ReelList1 from "../../assets/ReelList1.png";
import ReelList2 from "../../assets/ReelList2.png";
import ReelListh from '../../assets/ReelListh.png';
import StoriesList1 from "../../assets/StoriesList1.png";
import StoriesList2 from "../../assets/StoriesList2.png";
import StoriesListh from '../../assets/StoriesListh.png'
import ReportList1 from "../../assets/ReportList1.png";
import ReportList2 from "../../assets/ReportList2.png";
import UserList1 from '../../assets/UserList1.png';
import UserList2 from '../../assets/UserList2.png';
import UserListh from '../../assets/UserListh.png'
import CountryWise1 from '../../assets/CountryWise1.png'
import CountryWise2 from '../../assets/CountryWise2.png'
import CountryWiseh from '../../assets/Flagh.png'
import HashtagList1 from "../../assets/HashtagList1.png";
import HashtagList2 from "../../assets/HashtagList2.png";
import HashtagListh from '../../assets/HashtagListh.png';
import LanguageList1 from '../../assets/LanguageList1.png';
import LanguageList2 from '../../assets/LanguageList2.png';
import LanguageListh from '../../assets/LanguageListh.png';
import BlockList1 from '../../assets/BlockList1.png';
import BlockList2 from '../../assets/BlockList2.png';
import BlockListh from '../../assets/BlockListh.png'
import AvatarList1 from '../../assets/AvatarList1.png';
import AvatarList2 from '../../assets/AvatarList2.png';
import AvatarListh from '../../assets/AvatarListh.png';
import Notification1 from '../../assets/Notification1.png';
import Notification2 from '../../assets/Notification2.png';
import Notificationh from '../../assets/Notificationh.png'
import Settings1 from "../../assets/settings1.png";
import Settings2 from "../../assets/settings2.png";
import Settingsh from '../../assets/Settingsh.png'
import Profile1 from "../../assets/profile1.png";
import Profile2 from "../../assets/profile2.png";
import Profileh from '../../assets/Profileh.png'
import cms1 from '../../assets/cms1.png';
import cms2 from '../../assets/cms2.png';
import cmsh from '../../assets/cmsh.png'
import Logout1 from "../../assets/logout1.png";
import Logout2 from "../../assets/logout2.png";
import Logouth from '../../assets/Logouth.png'
import LogoutDialog from '../Logout/LogoutPopup';
import Arrow from '../../assets/Arrow.png';
import Cookies from 'js-cookie'
import sidebarSlice from '../../store/slice/StoreSidebarValue'
import { MdKeyboardArrowLeft } from "react-icons/md";

const options1 = [
  {
    name: "DASHBOARD",
    subOptions: [
      { name: "Dashboard", path: "/dashboard", src:Dashboard1,src1:Dashboard2,srch:Dashboardh },
    ],
  },
  {
    name: "POST",src:ReportList1,src1:ReportList2,
    subOptions: [
      { name: "Post List", path: "/post-list", src:PostList1,src1:PostList2,srch:PostListh },
      { name: "Reel List", path: "/reel-list", src:ReelList1, src1:ReelList2,srch:ReelListh },
      { name: "Stories List", path: "/stories-list", src:StoriesList1,src1:StoriesList2, srch:StoriesListh },
    ],
  },
  {
    name: "LIST",src:ReportList1,src1:ReportList2,
    subOptions: [
      {
        name: "Report List", src: ReportList1, src1: ReportList2,
        sub: [
          { name: "User Report List", path: "/user-report-list" },
          { name: "Post Report List", path: "/post-report-list" },
          { name: "Reel Report List", path: "/reel-report-list" },
        ],
      },
      { name: "User List", path:'/user-list', src:UserList1, src1:UserList2, srch:UserListh},
      { name: "Countrywise Users", path:'/country-wise-users', src:CountryWise1,src1:CountryWise2, srch:CountryWiseh },
      { name: "Hashtag List", path: "/hashtag-list", src:HashtagList1, src1:HashtagList2, srch:HashtagListh },
      { name: "Language List", path: "/language-list", src:LanguageList1, src1:LanguageList2, srch:LanguageListh },
      // { name: "Music List", path: "/music-list", src:MusicList1, src1:MusicList2 },
      { name: "Block List", path: "/block-list", src:BlockList1, src1:BlockList2, srch:BlockListh },
      { name: "Avatar List", path: "/avatar-list", src:AvatarList1, src1:AvatarList2, srch:AvatarListh },
       { name: "Chat Room", path:'/chat-room', src:UserList1, src1:UserList2, srch:UserListh },
        { name: "App Control", path:'/app-control', src:UserList1, src1:UserList2, srch:UserListh },
        { name: "Trending Config", path:'/trending-config', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Weekly Report", path:'/weekly-report', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Top Stories", path:'/top-stories', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Banners", path:'/banner-list', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Weekly Reset", path:'/weekly-reset', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "User Levels", path:'/user-levels', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Follower Levels", path:'/follower-levels', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Group Levels", path:'/group-levels', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Frames", path:'/frames', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Greedy Cafe", path:'/greedy-cafe', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Gift Catalog", path:'/gift-list', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Agency List", path:'/agency-list', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Room Themes", path:'/room-themes', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Treasure Box", path:'/treasure-box', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Battle Durations", path:'/battle-durations', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Tournaments", path:'/tournaments', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Hashtag Categories", path:'/hashtag-category', src:HashtagList1, src1:HashtagList2, srch:HashtagListh },
            { name: "CP Categories", path:'/cp-categories', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "CP Connections", path:'/cp-connections', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Post Coin Settings", path:'/post-coin-settings', src:UserList1, src1:UserList2, srch:UserListh },
            { name: "Post Coin Withdrawals", path:'/post-coin-withdrawals', src:UserList1, src1:UserList2, srch:UserListh },

    ],
  },
  {
    name: "NOTIFICATION",
    subOptions: [
      { name: "Push Notification",path:'/push-notification', src:Notification1, src1:Notification2, srch:Notificationh  },
    ],
  },
  {
    name: "SETTING",
    subOptions: [
      { name: "Settings",path:"/settings", src:Settings1,src1:Settings2,srch:Settingsh },
      { name: "Profile",path:'/profile', src:Profile1, src1:Profile2, srch:Profileh },
      { name: "CMS Pages", path:'/cms', src:cms1, src1:cms2, srch:cmsh},
    ],
  },
  
];

function Sidebar({isOpen,onClose}) {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleDelete = () => {
    handleClose();
  };
  
  const toggleSubMenu = (name) => {
    setOpenSubMenu(openSubMenu === name ? null : name);
  };

  const handleRemove = () => {
    Cookies.remove("userId")
  }

  const [sidebarOpen,setSidebarOpen] = useState(false)
  const dispatch = useDispatch();
const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

// Example: toggle
const handleSidebar = () => {
  dispatch(toggleSidebar());
};

  return (
    <>
  
      {/* <div className={`xl:w-72 text-[#5B5B5B] left-0 top-0 z-50 bg-[#FFFFFF] xl:bg-transparent 2xl:bg-transparent dark:bg-primary dark:text-darkText flex flex-col gap-10 fixed border border-[#F2F2F2] dark:border-[#1F1F1F]`}> */}
      <div className={`transition-all duration-300 h-screen ${isSidebarOpen ? "w-20" : "xl:w-72"} text-[#5B5B5B] left-0 top-0 z-50 bg-[#FFFFFF] xl:bg-transparent 2xl:bg-transparent dark:bg-primary dark:text-darkText flex flex-col gap-10 fixed border border-[#F2F2F2] dark:border-[#1F1F1F]`}>

       
{/* Entire Sidebar Container */}
<div className="flex flex-col h-full">

{/* Top Section: Logo & Toggle Arrow */}
<div className="flex items-center justify-between px-6 pt-8">
  <div className="flex items-center gap-2">
    <img src={logo} className="w-8 h-8" />
    {!isSidebarOpen && <img src={Snapta} alt="snapta" className="w-[75px]" />}
  </div>
  {/* Arrow */}
  <div className="absolute z-50 -right-3 top-4">
    <MdKeyboardArrowLeft
      className={`w-6 h-6 cursor-pointer bg-[#5B5B5B] bg-opacity-25 xl:block hidden dark:text-[#FFFFFF] transition-transform duration-300 ${isSidebarOpen ? "" : "rotate-180"}`}
      onClick={handleSidebar}
    />
  </div>
  {/* Mobile close button */}
  <button onClick={onClose} className="absolute text-2xl text-gray-600 top-4 right-4 dark:text-white xl:hidden">
    ×
  </button>
</div>

{/* Scrollable Menu Section */}
<div className="flex-1 pr-1 mt-6 overflow-y-auto custom-scrollbar">
  <div className="space-y-3">
    {options1.map((section, index) => (
      <div key={section.name}>
        {!isSidebarOpen && (
          <div className="px-6 pb-3 text-base font-semibold tracking-wide text-[#000000] dark:text-darkText text-opacity-[53%]">
            {section.name}
          </div>
        )}

        {/* Section Items */}
        {section.subOptions.map((item,index) => {
        // if (item.name === "Logout") {
        //   return (
        //     <>
        //     <button
        //       key={item.name}
        //       onClick={handleOpen}
        //       className="flex items-center w-full py-3 transition-all duration-200 px-7">
        //       <img src={Logout1} className="w-5 h-5" alt="Logout" />
        //       <span className={`ml-3 text-base  font-poppins text-[#5B5B5B] dark:text-[#AAAAAA] ${isSidebarOpen ? "hidden" : ""}`}>Logout</span>
        //     </button>
        //     </>
        //   );
        // }

        return (
          <div key={item.name} className="relative ml-2">
            {/* Main Option (with nested sub if exists) */}
            <div
              className="left-0 flex items-center justify-between w-full px-6 py-3 transition-all duration-200 cursor-pointer"
              onClick={() => item.sub ? toggleSubMenu(item.name) : null}
            >
              
              {item.sub ? (
                <div className="flex items-center w-full">
                  <img src={item.src} className="w-5 h-5" alt={item.name} /> 
                  {/* {item.sub  && <item.icon className={`w-5 h-5 ${isActive ? "text-header" : "text-gray-500"}`}/>} */}
                  <span className={`ml-3 text-sm font-poppins text-[#5B5B5B] dark:text-[#AAAAAA] ${isSidebarOpen ? "hidden" : ""}`}>{item.name}</span>

                </div>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center w-full ${
                      isActive
                        ? "text-transparent bg-clip-text bg-header font-semibold"
                        : ""
                    }`
                  }
                  onClick={handleRemove}
                >
                  {({ isActive }) => (
                    <div className="flex items-center group ">
                    {isActive && (
                       <div className="absolute w-1 h-5 rounded-r -left-2 top-3 bottom-3 bg-header"/>  //for the left line of active button
                    )}

                      <div className="relative w-5 h-5">
  {/* Default icon (always visible unless hovered in dark mode) */}
  <img 
    src={isActive ? item.src1 : item.src} 
    className="w-5 h-5 dark:group-hover:hidden" 
    alt="default" 
  />

  {/* Hover icon (only visible on hover in dark mode) */}
  <img 
    src={isActive ? item.src1 : item.srch} 
    className="absolute top-0 left-0 hidden w-5 h-5 dark:group-hover:block" 
    alt="hover" 
  />
</div>


                      {/* <span className={` ml-3 text-sm font-poppins  ${isActive ? "text-[#593A99]" : "text-[#5B5B5B] dark:text-[#AAAAAA]"}`}>{item.name}</span> */}
                      <span className={`ml-3 text-sm font-poppins ${isActive ? "text-[#593A99]" : "text-[#5B5B5B] dark:text-[#AAAAAA]"} ${isSidebarOpen ? "hidden" : ""}`}>
  {item.name}
</span>

                    </div>
                  )}
                </NavLink>
              )}

              {/* Arrow icon */}
              {item.sub && (
                <img
                  src={Arrow}
                  className={`w-4 h-4 transition-transform duration-200 ${
                    openSubMenu === item.name ? "" : "-rotate-90"} ${isSidebarOpen ? "hidden" : ""}`
                  }
                  alt="Toggle Submenu"
                />
              )}
            </div>

            {/* Sub-options if present */}
            {item.sub && openSubMenu === item.name && (
              <div className={`relative ml-6 ${isSidebarOpen ? "hidden" : ""}`}>
                <div className="absolute left-2 top-0 bottom-0 w-0.5 h-[87px] bg-gray-300 dark:bg-[#1F1F1F]"></div>
                <div className="pl-4">
                  {item.sub.map((subItem) => (
                    <div key={subItem.name} className="relative flex items-center">
                      <div className="absolute w-4 h-2 border-b-2 border-l-2 border-gray-300 dark:border-[#1F1F1F] rounded-bl-lg -left-2"></div>
                      <NavLink
                        to={subItem.path}
                        className={({ isActive }) =>
                          `flex items-center w-full px-6 py-2 transition-all duration-200 ${
                            isActive
                              ? " text-[#593A99] font-semibold"
                              : "dark:text-[#AAAAAA] text-[#5B5B5B]"
                          }`
                        }
                        onClick={handleRemove}
                      >
                        <span className={`text-sm font-poppins ${isSidebarOpen ? "hidden" : ""}`}>{subItem.name}</span> 
                      </NavLink>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
      </div>
    ))}
  </div>
</div>

</div>



      </div>

      <LogoutDialog open={open} handleClose={handleClose} handleDelete={handleDelete} />

    </>
  );
}

export default Sidebar;


